<template>
    <section
        class="container relative md:mb-48 mt-36 md:mt-96 xl:px-24 2xl:px-80"
    >
        <div class="grid-cols-1 xl:grid-cols-7 md:grid gap-y-24 xl:gap-x-48">
            <div class="col-span-4">
                <div class="relative inline-block">
                    <div class="pb-8 overflow-hidden">
                        <ParagraphComponent
                            ref="paragraph"
                            class="max-w-[450px]"
                            :text="project.introTxt"
                        />
                    </div>
                    <div
                        class="absolute right-0 h-[1px] w-screen bg-primary lg:right-0"
                    ></div>
                </div>
            </div>
            <div class="relative inline-block col-span-3 mt-28 md:mt-0">
                <div ref="infoGroup" class="flex flex-col gap-y-6">
                    <div class="flex flex-col gap-y-2">
                        <h3 class="font-bold">Services</h3>
                        {{ categoriesList }}
                    </div>
                    <div class="h-[1px] w-full bg-primary"></div>
                    <div
                        v-if="project.clients?.length > 0"
                        class="flex flex-col gap-y-2"
                    >
                        <h3 class="font-bold">Client</h3>
                        <span>{{ project.clients[0] }}</span>
                    </div>
                    <div
                        v-if="project.liveSite"
                        class="h-[1px] w-full bg-primary"
                    ></div>
                    <div v-if="project.liveSite" class="flex flex-col gap-y-2">
                        <h3 class="font-bold">Live Website</h3>
                        <a
                            :href="liveSiteLink"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ formattedLiveSite }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    project: {
        type: Object,
        default: () => ({}),
    },
    categoriesList: {
        type: String,
        default: '',
    },
});

// Refs
const paragraph = ref();
const infoGroup = ref();

// Computed
const liveSiteLink = computed(() => {
    return `${props.project?.liveSite}?ref=raphaelbernhart.at`;
});
const formattedLiveSite = computed(() => {
    return props.project?.liveSite.replace(/(^\w+:|^)\/\//, '');
});

// Methods
const initAnimations = () => {
    const infoGroupElements = useGsap.utils.toArray(infoGroup.value?.children);
    const elements = [paragraph.value.$el, ...infoGroupElements];

    useNuxtApp().$staggerFadeUpAnimations(elements, {
        triggerElement: paragraph.value.$el,
        stagger: 0.2,
    });
};

// Hooks
onMounted(() => {
    initAnimations();
});
</script>
